<template>
  <v-form >
      <v-form v-if="this.$vuetify.breakpoint.xsOnly" >
        <v-container flat style="text-align:center " id="packageList">
           <v-layout>
                <v-flex  v-for="item in paginate" :key="item.id" >
                    
                     <div class="elevation-5" style="text-align:center; padding:0px; cursor:pointer;" :class= "{'greenBorder': (item.id==keepColor&&item.packagesFno.packagesFnoCat.packageCatType==='Residential'), 
                    'redBorder': (item.id==keepColor&&item.isPromotion),
                    'blueBorder': (item.id==keepColor&&item.packagesFno.packagesFnoCat.packageCatType==='Business')
                    }" hover  height="210px"  max-width="120px" name="packageCard" @click="selectPackage(item.id, item)" :id="item.id">
                         <v-toolbar height= "20px"  v-if="item.isPromotion" flat color="red"><v-spacer />
                            <v-toolbar-title style="font-size: 12px; text-align:center;" class="white--text ">
                                PROMO DEAL
                            </v-toolbar-title><v-spacer />
                        </v-toolbar>
                        <v-toolbar height= "20px" class= "text-xs-center" v-else-if="item.packagesFno.packagesFnoCat.packageCatType==='Residential'" flat color="primary">
                             <v-spacer />   <v-toolbar-title style="font-size: 12px" class="white--text text-xs-center ">
                                RESIDENTIAL
                            </v-toolbar-title><v-spacer />
                        </v-toolbar>
                        <v-toolbar height= "20px" class= "text-xs-center" v-else-if="item.packagesFno.packagesFnoCat.packageCatType==='Business'" flat color="light-green lighten-2">
                             <v-spacer />   <v-toolbar-title style="font-size: 12px" class="white--text text-xs-center ">
                                BUSINESS
                            </v-toolbar-title><v-spacer />
                        </v-toolbar> 
                         <v-responsive class="px-2">
                            <v-img :src="$store.state.currentOrg.org.logo" max-height="50" aspect-ratio="1.4" contain></v-img>
                        </v-responsive>
                        
                        <v-card-text>
                       
                                <h3 v-if="item.isFup" style="text-align:center;font-size: 18px;" class="grey--text">
                                    <v-icon size="medium">arrow_downward</v-icon>
                                    {{item.packagesFno.speedProfile.downloadMbps}}
                                    <v-icon size="medium">arrow_upward</v-icon>
                                    {{item.packagesFno.speedProfile.uploadMbps}} 
                                </h3>
                                <h3 v-if="!item.isFup" style="text-align:center;font-size: 18px;" class="grey--text">
                                   <v-icon size="medium">arrow_downward</v-icon>
                                    {{item.packagesFno.speedProfile.downloadMbps}}
                                    
                                    <v-icon size="medium">arrow_upward</v-icon>
                                    {{item.packagesFno.speedProfile.uploadMbps}} 
                                    
                                </h3> 
                            
                               <br v-if="!item.isFup">
                               <span  v-if="item.isFup"> <v-chip style="font-size: 12px" small  dark color="orange">FUP</v-chip>
                                </span>  

                            <v-form class="grey--text">
                                <h1 style="font-size: 15px"><span v-if="item.hasSpecificTerms">*</span> {{item.recurringPriceVatInc|currency}}</h1>
                            </v-form>

                        </v-card-text>                       
                      
                            <v-btn small round v-if="item.isPromotion" @click="showPackageMobile = true; selectedPackage = item; moreInfoClicked = true" flat class="justify-center white--text" color="red"><v-icon medium>info</v-icon> Info</v-btn>
                            <v-btn small round v-else-if="item.packagesFno.packagesFnoCat.packageCatType==='Business'" @click="showPackageMobile = true; selectedPackage = item; moreInfoClicked = true" flat class="justify-center white--text " color="light-blue lighten-2"><v-icon medium>info</v-icon> Info</v-btn>
                            <v-btn small round v-else @click="showPackageMobile = true; selectedPackage = item; moreInfoClicked = true" flat class="justify-center white--text" color="primary"><v-icon medium>info</v-icon> Info</v-btn>
                     <br></br>
                      
                     
                    </div>
                </v-flex>
            </v-layout>
            </v-container>
            <v-container  style="text-align:center;">
                    <v-layout>
                    <v-flex cols="4" sm3>       
                        <v-btn depressed v-if="currentPage!==1&&totalPages>1" small color="grey" text @click="setPage(currentPage -1)">
                            <v-icon>chevron_left</v-icon>
                        </v-btn>
                        <v-btn depressed v-else v-show="totalPages>1" disabled small color="grey" text @click="setPage(currentPage -1)">
                            <v-icon>chevron_left</v-icon>
                        </v-btn>
                     </v-flex>
                     
                    <v-flex cols="4" sm3>  
                                <v-btn depressed v-for="pageNumber in totalPages"  v-if="currentPage===pageNumber&&totalPages>1" round small color="primary" @click="setPage(pageNumber)">{{pageNumber}}</v-btn>
                            <v-btn depressed class="hidden-sm-and-down" v-else-if="totalPages>1&&(pageNumber===(currentPage+1)||pageNumber===(currentPage-1)||(currentPage===1&&pageNumber===3)||(currentPage===totalPages&&pageNumber===(totalPages-2)))" small color="grey" text @click="setPage(pageNumber)">{{pageNumber}}</v-btn>
                      </v-flex>
                    <v-flex cols="4" sm3> 
                        <v-btn depressed v-if="currentPage<totalPages&totalPages>1" small color="grey" text @click="setPage(currentPage +1)">
                            <v-icon >chevron_right</v-icon>
                        </v-btn>
                        <v-btn depressed v-else  v-show="totalPages>1" disabled small color="grey" text @click="setPage(currentPage +1)">
                            <v-icon >chevron_right</v-icon>
                        </v-btn>
           </v-flex></v-layout>
        </v-container>
     </v-form>

      <div v-if="this.$vuetify.breakpoint.smAndUp">
        <v-container class="px-2" flat style="text-align:center px-0" id="packageList" >
           <v-layout >
                <v-flex cols="12" sm="2" v-for="item in paginate" :key="item.id">
                    
                   <!-- <v-card :class= "{'greenBorder': item.id==keepColor }"  v-bind:style= "[styleTrue ? {'border' : '3px solid #00a3da;'} : {'border' :' 3px solid ##34c3eb;'}]"   hover min-height="450px"  min-width="160px" max-width="160px" name="packageCard" @click="prt(item.id, keepColor); selectPackage(item.id, item)" :id="item.id">-->
                    <div class="elevation-5" style="text-align:center; padding:0px;cursor:pointer;" :class= "{'greenBorder': (item.id==keepColor&&item.packagesFno.packagesFnoCat.packageCatType==='Residential'), 
                    'redBorder': (item.id==keepColor&&item.isPromotion),
                    'blueBorder': (item.id==keepColor&&item.packagesFno.packagesFnoCat.packageCatType==='Business')
                    }" hover height="450px" width="180px" name="packageCard" @click="selectPackage(item.id, item)" :id="item.id">
                        <v-toolbar  height= "35px"  v-if="item.isPromotion" flat color="red">
                        <v-spacer />
                            <v-toolbar-title style="font-size: 18px;" class=" white--text">
                             PROMO DEAL
                            </v-toolbar-title>
                            <v-spacer />
                        </v-toolbar>
                        <v-toolbar height= "35px"  v-else-if="item.packagesFno.packagesFnoCat.packageCatType==='Residential'" flat color="primary">
                               <v-spacer />
                                <v-toolbar-title style="font-size: 18px" class="white--text">
                                RESIDENTIAL
                            </v-toolbar-title>
                            <v-spacer />
                        </v-toolbar>
                        <v-toolbar height= "35px" v-else-if="item.packagesFno.packagesFnoCat.packageCatType==='Business'" flat color="light-green lighten-2">
                               <v-spacer /> <v-toolbar-title style="font-size: 18px" class="white--text ">
                                BUSINESS
                            </v-toolbar-title><v-spacer />
                        </v-toolbar> 
                        <v-responsive class="pt-4 px-2">
                            <v-img :src="$store.state.currentOrg.org.logo" max-height="50" aspect-ratio="1.4" contain></v-img>
                        </v-responsive>
                        <v-card-text>
                            <v-form>
                                <span class="grey--text" v-if="item.isCapped">CAPPED</span>
                                <span class="grey--text" v-else>UNCAPPED</span> / <br>
                                <span class="grey--text" v-if="item.isShaped"> SHAPED</span>
                                <span class="grey--text" v-else>UNSHAPED</span>

                            </v-form>
                            <v-form >
                                <h3 v-if="item.isFup" style="font-size: 20px" class="grey--text">
                                    <v-icon>arrow_downward</v-icon>
                                    {{item.packagesFno.speedProfile.downloadMbps}}
                                    <v-icon>arrow_upward</v-icon>
                                    {{item.packagesFno.speedProfile.uploadMbps}} 
                                    <br v-if="item.packagesFno.speedProfile.downloadMbps<=9 && item.packagesFno.speedProfile.uploadMbps<=9" > Mbps
                                </h3>
                                <h3 v-else style="font-size: 20px" class="grey--text">
                                    <v-icon>arrow_downward</v-icon>
                                    {{item.packagesFno.speedProfile.downloadMbps}}
                                    <v-icon>arrow_upward</v-icon>
                                    {{item.packagesFno.speedProfile.uploadMbps}}  
                                    <br v-if="item.packagesFno.speedProfile.downloadMbps<=9 && item.packagesFno.speedProfile.uploadMbps<=9" > Mbps
                                </h3>
                                <v-chip style="font-size: 10px" small v-if="item.isFup" dark color="orange">FAIR USAGE POLICY</v-chip>
                            </v-form>

                          <br v-if="!item.isFup">
                            <v-divider v-if="item.isFup" class="mt-3"></v-divider>
                            <v-divider v-else class="mt-4"></v-divider>
                            <v-form class="grey--text">
                                <h1 style="font-size: 20px">{{item.recurringPriceVatInc|currency}}</h1>p/m <span v-if="item.hasSpecificTerms">*</span>
                            </v-form>
                            <v-divider></v-divider>

                            <v-form class="grey--text py-2">{{item.onceOffPriceVatInc|currency}} Once-off</v-form>
                            <v-form class="text-uppercase grey--text" style="font-size: 12px">{{item.term}}</v-form>
                           
                            <v-divider></v-divider> 
                        </v-card-text>
                        
                        <v-layout v-if="$vuetify.breakpoint.lgAndUp">
                       <v-flex  cols="12" sm12>
                            <v-btn small round v-if="item.isPromotion" @click="showPackage = true; selectedPackage = item; moreInfoClicked = true" flat class="white--text pl-0" color="red"><v-icon medium>info</v-icon> Info</v-btn>
                            <v-btn small round v-else-if="item.packagesFno.packagesFnoCat.packageCatType==='Business'" @click="showPackage = true; selectedPackage = item; moreInfoClicked = true" flat class="white--text pl-0" color="light-green lighten-2"><v-icon medium>info</v-icon> Info</v-btn>
                            <v-btn small round v-else @click="showPackage = true; selectedPackage = item; moreInfoClicked = true" flat class="white--text pl-0" color="primary"><v-icon medium>info</v-icon> Info</v-btn>
                     
                            <v-btn small round v-if="item.isPromotion" color="red" class="white--text"> SELECT</v-btn>
                            <v-btn small round v-else-if="item.packagesFno.packagesFnoCat.packageCatType==='Business'" class="white--text" color="light-green lighten-2"> SELECT</v-btn>
                            <v-btn small round v-else color="primary">SELECT</v-btn>
                         
                        </v-flex>  
                         </v-layout>
                         
                       
                        
                          <v-flex v-if="$vuetify.breakpoint.mdAndDown" cols="12" sm12>
                            <v-btn small round v-if="item.isPromotion && $vuetify.breakpoint.mdAndDown" @click="showPackage = true; selectedPackage = item; moreInfoClicked = true" text style="padding-right:0px" class="justify-left white--text pr-0 ml-0" color="red"><v-icon style="padding-right:0px" small>info</v-icon> Info</v-btn>
                            <v-btn small round v-else-if="item.packagesFno.packagesFnoCat.packageCatType==='Business'&& $vuetify.breakpoint.mdAndDown" @click="showPackage = true; selectedPackage = item; moreInfoClicked = true" text class="pr-0 justify-left white--text " color="light-blue lighten-2"><v-icon  small>info</v-icon> Info</v-btn>
                            <v-btn small round v-else-if="$vuetify.breakpoint.mdAndDown" @click="showPackage = true; selectedPackage = item; moreInfoClicked = true" text class="justify-left white--text pr-0" color="primary"><v-icon  small>info</v-icon> Info</v-btn>
                    
                            <v-btn small round v-if="item.isPromotion&& $vuetify.breakpoint.mdAndDown&& $vuetify.breakpoint.mdAndDown" color="red"  class="white--text "> SELECT</v-btn>
                            <v-btn small round v-else-if="item.packagesFno.packagesFnoCat.packageCatType==='Business'&& $vuetify.breakpoint.mdAndDown" class="white--text " color="light-blue lighten-2 "> SELECT</v-btn>
                            <v-btn small round v-else-if="$vuetify.breakpoint.mdAndDown" color="primary"  >SELECT</v-btn>
                 </v-flex>
                 
                      
                          
                          
                     
                    </div>

              


                </v-flex>
            </v-layout>
            </v-container>
            <v-container  style="text-align:center;">
                <v-layout>
                    <!-- <v-flex cols="12" sm12>
                        <span class="grey--text">* Indicates that the package has additional specific Terms & conditions. These can be seen by clicking on the info button of the releveant package.</span>
                    </v-flex> -->
                </v-layout>
                            <v-layout>
                    <v-flex cols="6" sm="4">   
                        <v-btn depressed v-if="currentPage!==1&&totalPages>1" small color="grey" text @click="setPage(currentPage -1)">
                            <v-icon>chevron_left</v-icon>
                        </v-btn>
                        <v-btn depressed v-else v-show="totalPages>1" disabled small color="grey" text @click="setPage(currentPage -1)">
                            <v-icon>chevron_left</v-icon>
                        </v-btn>
                        </v-flex>
                         <v-flex cols="6" sm="4">  
                                <v-btn depressed v-for="pageNumber in totalPages"  v-if="currentPage===pageNumber&&totalPages>1" round small color="primary" @click="setPage(pageNumber)">{{pageNumber}}</v-btn>
                            <v-btn depressed class="hidden-sm-and-down" v-else-if="totalPages>1&&(pageNumber===(currentPage+1)||pageNumber===(currentPage-1)||(currentPage===1&&pageNumber===3)||(currentPage===totalPages&&pageNumber===(totalPages-2)))" small color="grey" text @click="setPage(pageNumber)">{{pageNumber}}</v-btn>
                        </v-flex>
                         <v-flex cols="6" sm="4">  
                        <v-btn depressed v-if="currentPage<totalPages&totalPages>1" small color="grey" text @click="setPage(currentPage +1)">
                            <v-icon >chevron_right</v-icon>
                        </v-btn>
                        <v-btn depressed v-else  v-show="totalPages>1" disabled small color="grey" text @click="setPage(currentPage +1)">
                            <v-icon >chevron_right</v-icon>
                        </v-btn>
</v-flex></v-layout>
        </v-container>
     </div>

        <!-- Modals -->
        <!-- package View modal -->
        <v-dialog v-model="showPackage"
        persistent
                  min-width="200px"
                  max-width="800px"
                  >
            <v-card>
                <v-card-title class="headline"  primary-title>
                    <v-img :src="$store.state.currentOrg.org.logo" px-5 max-height="55" aspect-ratio="1.4" contain style="        text-align: left;"></v-img>
                    <v-spacer></v-spacer>
                    <span class="mr-4 grey--text font-weight-bold" >{{selectedPackage.name}}</span>
                </v-card-title>
                <v-divider></v-divider>
                <br>
                <v-card-text>
                     <h2 class="text-xs-center grey--text">Package details</h2>
                  <v-layout row wrap>
                        <v-flex>
                            <v-form style="text-align: left; padding: 15px">
        <v-container grid-list-xs>
            <v-layout wrap >
                    <v-flex class=" text-xs-left px-0">
                        <h4 class="packageElement">Download speed: </h4>
                        <h4 class="packageElement">Upload speed: </h4>
                        <h4 class="packageElement">Data: </h4>
                        <h4 class="packageElement">Contract Term: </h4>
                        <h4 class="packageElement">Shaped: </h4>
                    </v-flex>
                    <v-flex class="text-xs-left px-0">
                        <h4 class="packageValue"><b>{{selectedPackage.packagesFno.speedProfile.downloadMbps}} Mbps</b></h4>
                        <h4 class="packageValue"><b>{{selectedPackage.packagesFno.speedProfile.uploadMbps}} Mbps</b></h4>
                        <h4 class="packageValue"  v-if="selectedPackage.isCapped"><b>Capped ({{selectedPackage.cappedAmountGb}}Gb)</b></h4>
                        <h4 class="packageValue"  v-else><b>Uncapped</b></h4>
                        <h4 class="packageValue" ><b>{{selectedPackage.term}}</b></h4>
                        <h4 class="packageValue"  v-if="selectedPackage.isShaped"><b>Yes</b></h4>
                        <h4 class="packageValue"  v-else><b>No</b></h4>
                    </v-flex>
                  </v-layout >
                </v-container >
                     </v-form>
                        </v-flex>
                        <v-flex>
        <v-form style=" text-align: left; padding: 15px">
        <v-container grid-list-xs>
            <v-layout wrap >
                    <v-flex class=" text-xs-left px-0">
                        <h4 class="packageElement">ISP Once-off Price: </h4>
                        <h4 class="packageElement">ISP Monthly Price: </h4>
                         <v-tooltip bottom>
                                                                    <template v-slot:activator="{ on }">
                                                                        <a target="_blank"
                                                                           :href= "$store.state.currentOrg.org.termsAndConditionsLink"
                                                                           @click.stop
                                                                           v-on="on">
                                                                           Terms and Conditions
                                                                        </a>
                                                                    </template>
                                                                    Open link to view T's & C's
                                                                </v-tooltip> 
                    </v-flex>
                    <v-flex class="text-xs-left px-0">
                        <h4 class="packageValue"><b>{{selectedPackage.onceOffPriceVatInc|currency}}</b></h4>
                        <h4 class="packageValue" ><b>{{selectedPackage.recurringPriceVatInc|currency}} </b></h4>
                       
                    </v-flex>                       
                   </v-layout >
                 </v-container >
               </v-form>
              </v-flex>
             </v-layout>
                    <v-layout row wrap>
                        <v-flex v-if="selectedPackage.description!==null&&selectedPackage.description!==''" style="text-align: left; padding: 15px">
                            <v-form class="grey--text">
                                {{selectedPackage.description}}
                            </v-form>
                        </v-flex>
                    </v-layout>
                    <v-layout row wrap v-if="selectedPackage.isPromotion&&selectedPackage.promotionDescription!==null&&selectedPackage.promotionDescription!==''">
                        <v-flex style="text-align: left; padding: 15px">
                            <h3 class="grey--text">Promotion:</h3>
                            <v-form>
                                {{selectedPackage.promotionDescription}}
                            </v-form>
                        </v-flex>
                    </v-layout>
                    <v-layout row wrap v-if="selectedPackage.hasSpecificTerms&&selectedPackage.specificTerms!==null&&selectedPackage.specificTerms!==''">
                        <v-flex style="text-align: left; padding: 15px">
                            <h3 class="grey--text">Specific T's & C's:</h3>
                            <v-form class="grey--text">
                                {{selectedPackage.specificTerms}}
                            </v-form>
                        </v-flex>
                    </v-layout>

                      <v-container v-if="selectedPackage.isFup">                              
                    <v-layout row wrap >
                        <v-flex style=" text-align: left; padding: 15px">
                            <h3 style=" color: red">Please note!</h3>
   
                             
                                                        <v-form class="grey--text"> 
                                                        This package comes with a
                                                                <v-tooltip bottom>
                                                                    <template v-slot:activator="{ on }">
                                                                        <a target="_blank"
                                                                           :href= "$store.state.currentOrg.org.fupUrl"
                                                                           @click.stop
                                                                           v-on="on">
                                                                           Fair Usage Policy!
                                                                        </a>
                                                                    </template>
                                                                    Open link to view Fair Usage Policy
                                                                </v-tooltip>  
                                                                   </v-form>                                                         
                                                        
                                                       
                        </v-flex>
                    </v-layout>
                    </v-container>
                </v-card-text>
                <v-card-actions>
                    <v-spacer></v-spacer>
                    <v-btn color="primary"
                        dark
                           round
                           @click="showPackage = false; moreInfoClicked = false">
                        Close
                    </v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>
<!--////////////-->
            <v-dialog v-model="showPackageMobile"  persistent width="300px">
            <v-card > 
           <v-toolbar color="white">
                <v-toolbar-title class="compact-formInfo">
                        <span class="grey--text font-weight-bold" style="font-size:15px">{{selectedPackage.name}}</span>
                </v-toolbar-title>
                <v-spacer></v-spacer>
                 <v-btn  class="compact-formInfo" small color="primary"
                           @click="showPackageMobile = false; moreInfoClicked = false">
                           <v-icon small>clear</v-icon>   
                </v-btn>
                 </v-toolbar> 
    <v-content>
     
 <v-card-text>
                     <h3 class="text-xs-center grey--text">Package details</h3>
                    
                  <v-layout row wrap>
                        <v-flex>
                            <v-form style="text-align: left;">
                            
        <v-container grid-list-xs>
            <v-layout  wrap >
                    <v-flex cols="12" sm12 class=" text-xs-left px-0">
                        <h4 style="font-size:12px" class="packageElement">ISP: </h4>
                        <h4 style="font-size:12px" class="packageElement">Download speed: </h4>
                        <h4 style="font-size:12px" class="packageElement">Upload speed: </h4>
                        <h4 style="font-size:12px" class="packageElement">Data: </h4>
                        <h4 style="font-size:12px" class="packageElement">Contract Term: </h4>
                        <h4 style="font-size:12px" class="packageElement">Shaped: </h4>
                    </v-flex>
                    <v-flex cols="12" sm12 class="text-xs-left px-0">
                           <h4 style="font-size:12px" class="packageElement">ISP Once-off Price: </h4>
                        <h4 style="font-size:12px" class="packageElement">ISP Monthly Price: </h4>
                         <v-tooltip bottom>
                                                                    <template v-slot:activator="{ on }">
                                                                        <a target="_blank"
                                                                           :href= "$store.state.currentOrg.org.termsAndConditionsLink"
                                                                           @click.stop
                                                                           v-on="on">
                                                                           Terms and Conditions
                                                                        </a>
                                                                    </template>
                                                                    Open link to view T's & C's
                                                                </v-tooltip> 
                        <!-- <h4 style="font-size:12px" class="packageElement" :href="selectedPackage.customerOrganisation">Terms and Conditions </h4> -->
                    </v-flex>
                  </v-layout >
                </v-container >
                     </v-form>
                        </v-flex>
                        
                        <v-flex>
        <v-form style=" text-align: left; ">
        <v-container grid-list-xs>
            <v-layout wrap >
                    <v-flex cols="12" sm12 class=" text-xs-left px-0">
                    <v-spacer></v-spacer>
                         <h4 style="font-size:12px" class="packageValue"><b>{{$store.state.currentOrg.org.name}}</b></h4>
                         <h4 style="font-size:12px" class="packageValue"><b>{{selectedPackage.packagesFno.speedProfile.downloadMbps}} Mbps</b></h4>
                        <h4 style="font-size:12px" class="packageValue"><b>{{selectedPackage.packagesFno.speedProfile.uploadMbps}} Mbps</b></h4>
                        <h4 style="font-size:12px" class="packageValue"  v-if="selectedPackage.isCapped"><b>Capped ({{selectedPackage.cappedAmountGb}}Gb)</b></h4>
                        <h4 style="font-size:12px" class="packageValue"  v-else><b>Uncapped</b></h4>
                        <h4 style="font-size:12px" class="packageValue" ><b>{{selectedPackage.term}}</b></h4>
                        <h4 style="font-size:12px" class="packageValue"  v-if="selectedPackage.isShaped"><b>Yes</b></h4>
                        <h4 style="font-size:12px" class="packageValue"  v-else><b>No</b></h4>
                    </v-flex>
                    <v-flex cols="12" sm12 class="text-xs-left px-0">
                        <h4 style="font-size:12px" class="packageValue"><b>{{selectedPackage.onceOffPriceVatInc|currency}}</b></h4>
                        <h4 style="font-size:12px" class="packageValue" ><b>{{selectedPackage.recurringPriceVatInc|currency}} </b></h4>
                        <!-- <h4 style="font-size:12px" class="packageValue" ><b>{{selectedPackage.customerOrganisation.term}} </b></h4> -->
                    </v-flex>                       
                   </v-layout >
                 </v-container >
                     
               </v-form>
              
              </v-flex>
             </v-layout> 
                    <v-layout row wrap>
                        <v-flex v-if="selectedPackage.description!==null&&selectedPackage.description!==''" style="text-align: left; ">
                            <v-form class="grey--text">
                                {{selectedPackage.description}}
                            </v-form>
                        </v-flex>
                    </v-layout>
                    <v-layout row wrap v-if="selectedPackage.isPromotion&&selectedPackage.promotionDescription!==null&&selectedPackage.promotionDescription!==''">
                        <v-flex style="text-align: left;">
                            <h3 class="grey--text">Promotion:</h3>
                            <v-form>
                                {{selectedPackage.promotionDescription}}
                            </v-form>
                        </v-flex>
                    </v-layout>

                      <v-container v-if="selectedPackage.isFup">                              
                    <v-layout row wrap >
                        <v-flex style=" text-align: left; padding: 15px">
                            <h3 style=" color: red">Please note!</h3>
   
                             
                                                        <v-form class="grey--text"> 
                                                        This package comes with a
                                                                <v-tooltip bottom>
                                                                    <template v-slot:activator="{ on }">
                                                                        <a target="_blank"
                                                                           :href= "$store.state.currentOrg.org.fupUrl"
                                                                           @click.stop
                                                                           v-on="on">
                                                                           Fair Usage Policy!
                                                                        </a>
                                                                    </template>
                                                                    Open link to view Fair Usage Policy
                                                                </v-tooltip>  
                                                                   </v-form>                                                         
                                                        
                                                       
                        </v-flex>
                    </v-layout>
                    </v-container>
                </v-card-text>


    </v-content>
  

 </v-card>
        </v-dialog>

        <!-- Warning modal -->
        <v-dialog v-model="selectedPackageWarningModal"
                 >
            <v-card>
                <v-card-title class="headline grey lighten-2"
                              primary-title>
                    <b>Confirmation of selection</b>
                </v-card-title>

                <v-card-text>
                    Please confirm that you have selected an internet package.
                </v-card-text>

                <v-divider></v-divider>

                <v-card-actions>
                    <v-spacer></v-spacer>
                    <v-btn color="danger"
                           text
                           @click="selectedPackageWarningModal = false; clearPackageSelection() ">
                        No
                    </v-btn>
                    <v-btn color="primary"
                           text
                           @click="selectedPackageWarningModal = false">
                        Yes
                    </v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>
    </v-form>
</template>

<script>
    export default {
        props: ["packagesIsps", "cardsPerPage", "sizeScreen", "keepColor"],
        data() {
            return {
                contentProps: {
                    wrap: false,
                    row: false
                },
                showPackageMobile:false,
                currentPage: 1,
                primaryColour: '#FFE300',
                itemsPerPage: this.cardsPerPage,
                resultCount: 0,
                show: false,
                showPackage: false,
                moreInfoClicked: false,
                selectedPackageWarningModal: false,
                selectedId: null,
                selectedPackage: {
                    customerOrganisation: {},
                    locationNetwork: {},
                    packagesFno: {
                        speedProfile: {}
                    }
                },
                packageObj: {},
                styleTrue:true,
            };
        },
        watch: {
           
        },
         created(){
            
            },
        computed: {
            totalPages: function () {
                return Math.ceil(this.resultCount / this.cardsPerPage)
            },
            paginate: function () {
                if (!this.packagesIsps || this.packagesIsps.length != this.packagesIsps.length) {
                    return
                }
                
                this.resultCount = this.packagesIsps.length
                if (this.currentPage >= this.totalPages) {
                    this.currentPage = this.totalPages
                }
                var index = this.currentPage * this.cardsPerPage - this.cardsPerPage
                return this.packagesIsps.slice(index, index + this.cardsPerPage)
            }
        },
        methods: {
            borderFunc(obj){
              
                if(obj.id != null){

                document.getElementById(obj.id).style.backgroundColor = "#e6e6e6";                      
                       
                        if(!obj.isPromotion&&obj.packagesFno.packagesFnoCat.packageCatType==='Residential'){
                            document.getElementById(obj.id).style.border = "1px solid var(--v-primary-base)";
                        } else if(!obj.isPromotion&&obj.packagesFno.packagesFnoCat.packageCatType==='Business'){
                            document.getElementById(obj.id).style.border = "1px solid #34c3eb";
                        } else if(obj.isPromotion){
                            document.getElementById(obj.id).style.border = "1px solid #e60000";
                        }
                        
                        this.$emit('selectPackage', obj)
                }
            },
            openNewTab(url) {
                var win = window.open(url, '_blank');
                win.focus();
            },
            setPage: function (pageNumber) {
                this.currentPage = pageNumber
            },
            clearPackageSelection() {
                let elements = document.getElementsByName("packageCard")
                for (let i = 0; i < elements.length; i++) {
                    //elements[i].style.border = "1px solid lightgrey";
                    elements[i].style.border = "none";
                    elements[i].style.backgroundColor = "white";
                }
            },
            selectPackage(id, obj) {
                // if(obj.customer.ispSettings[0].primaryColour!==null){
                //     this.primaryColour=obj.customer.ispSettings[0].primaryColour
                // }
                if (!this.moreInfoClicked) {
                    this.clearPackageSelection();
                    if (id != this.selectedId) {
                        this.selectedId = id
                        document.getElementById(id).style.backgroundColor = "#e6e6e6";
                        
                        if(!obj.isPromotion&&obj.packagesFno.packagesFnoCat.packageCatType==='Residential'){
                            document.getElementById(id).style.border = "1px solid primary";
                        } else if(!obj.isPromotion&&obj.packagesFno.packagesFnoCat.packageCatType==='Business'){
                            document.getElementById(id).style.border = "1px solid #ccf59a";
                        } else if(obj.isPromotion){
                            document.getElementById(id).style.border = "1px solid #e60000";
                        }
                        
                        this.$emit('selectPackage', obj)
                    }
                    else if (id == this.selectedId) {
                        this.selectedId = null;
                        this.$emit('selectPackage', null)
                    }
                }
            }
        }
    };
</script>
<style>
    
    @media only screen and (min-width: 1904px)
    {
        .container{
        max-width: none !important
    }
    }

    .packageElement {
        font-weight: bold;
        color: darkgray;
    }

    .packageValue {
        font-weight: bold;
        color: var(--v-primary-base);
    }
     .mobileStep{
     font-size: 10px;
     
 }
 .largeStep{
      text-align:center ;
      min-height:470px ;
      max-width:160px
 }
.greenBorder{
    background-color : #e6e6e6;
    border : 1px solid var(--v-primary-base);
    text-align:center;
}
.blueBorder{
    background-color : #e6e6e6;
    border : 1px solid #34c3eb;
    text-align:center;
}
.redBorder{
    background-color : #e6e6e6;
    border : 1px solid red;
    text-align:center;
}
.greyBorder{
    border : 0.1px solid grey;
    text-align:center;
}


 
</style>
